import React from 'react';
import moment from 'moment';
import Card from '../../../../../components/Card';
import { ReactComponent as SpeakerIcon } from '../../../../../resource/SpeakerIcon.svg';
import styles from './AcceptanceNotificationCard.module.scss';

const momentFormat = (timeString, format) => moment(timeString).format(format);

const AcceptanceNotificationCard = ({ dateTime }) => {
  const date = momentFormat(dateTime, 'DD.MM.YYYY');
  const time = momentFormat(dateTime, 'HH:mm');

  return (
    <Card className={styles.root}>
      <div>
        <h5 className={styles.title}>Оповещение о приемке</h5>
        <p className={styles.text}>{`${date}, ${time}`}</p>
      </div>
      <SpeakerIcon />
    </Card>
  );
};

export default AcceptanceNotificationCard;
